if (!customElements.get('pl-image-link-blocks')) {
  class PlImageLinkBlocks extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.pl-image-link-blocks__rail');
      this.previousButton = this.querySelector('[data-pl-previous]');
      this.nextButton = this.querySelector('[data-pl-next]');

      if (!this.rail) return;

      this.handlePrevious = () => this.scrollByCard(-1);
      this.handleNext = () => this.scrollByCard(1);
      this.handleScroll = () => this.updateControls();
      this.handleResize = () => this.updateControls();

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.rail.addEventListener('scroll', this.handleScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this.rail);

      requestAnimationFrame(() => {
        this.rail.scrollTo({ left: 0, behavior: 'auto' });
        this.updateControls();
      });
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.rail?.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
    }

    scrollByCard(direction) {
      const card = this.rail.querySelector('.pl-image-link-blocks__card');
      if (!card) return;

      const styles = getComputedStyle(this.rail);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const distance = card.getBoundingClientRect().width + gap;

      this.rail.scrollBy({
        left: distance * direction,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth'
      });
    }

    updateControls() {
      if (!this.previousButton || !this.nextButton) return;

      const maxScroll = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      const currentScroll = Math.abs(this.rail.scrollLeft);
      const tolerance = 2;

      this.previousButton.disabled = currentScroll <= tolerance;
      this.nextButton.disabled = currentScroll >= maxScroll - tolerance;

      const hasOverflow = maxScroll > tolerance;
      this.previousButton.parentElement.hidden = !hasOverflow;
    }
  }

  customElements.define('pl-image-link-blocks', PlImageLinkBlocks);
}
